import { descriviQuota, percento, voceDifficolta } from './Functions'
import { Drawer } from './Overlay'
import { t } from './testi'

/**
 * L'analisi degli scenari in difficoltà: per ognuno quota, quante run lo hanno mancato e
 * quale controllo cade più spesso.
 * @param {Object} props - Proprietà
 * @param {Object} props.difficolta - L'analisi del server (`scenari`, `sotto`, `prove`, `fallite`, `voci`)
 * @param {() => void} props.onClose - Chiusura
 */
export const DrawerDifficolta = ({ difficolta, onClose }) => {
  const voci = voceDifficolta(difficolta.voci ?? [])
  return (
    <Drawer etichetta={t.aeAnalisi} chiudiEtichetta={t.aeChiudiForm} onClose={onClose} largo>
      <h3 className="ncard__title">{t.aeAnalisi}</h3>
      <p className="ae-muto">{t.aeAnalisiSotto}</p>
      <p className="ae-muto">
        {difficolta.scenari} {t.aeScenariEseguiti} · {difficolta.sotto} {t.aeSottoPieno} ·{' '}
        {percento(difficolta.fallite, difficolta.prove)} {t.aeProveFallite}
      </p>
      {voci.length ? (
        <div className="ae-tabella-scroll">
          <table className="ae-tabella ae-tabella--analisi">
            <thead>
              <tr>
                <th scope="col">{t.aeColScenario}</th>
                <th scope="col">{t.aeColQuota}</th>
                <th scope="col">{t.aeColFallite}</th>
                <th scope="col">{t.aeColSottoSoglia}</th>
                <th scope="col">{t.aeColCade}</th>
              </tr>
            </thead>
            <tbody>
              {voci.map((voce) => (
                <tr key={voce.id}>
                  <td>
                    <div>{voce.id}</div>
                    <div className="ae-muto">{voce.situazione || voce.descrizione}</div>
                  </td>
                  <td className="ae-tabella__num">{descriviQuota(voce.successi, voce.prove)}</td>
                  <td className="ae-tabella__num">
                    {percento(voce.prove - voce.successi, voce.prove)}
                  </td>
                  <td className="ae-tabella__num">
                    {percento(voce.runSottoSoglia, voce.run)}
                    <span className="ae-muto">
                      {' '}
                      · {voce.runSottoSoglia}/{voce.run}
                    </span>
                  </td>
                  <td className="ae-muto">
                    {voce.cadutoPiuSpesso
                      ? `${voce.cadutoPiuSpesso} · ${voce.volteCaduto}× · ${percento(voce.volteCaduto, voce.prove)}`
                      : '—'}
                    {voce.interruzioni ? (
                      <div>
                        {percento(voce.interruzioni, voce.prove)} {t.aeDiCuiInterrotte}
                      </div>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="ae-muto ae-vuoto">{t.aeNessunaDifficolta}</p>
      )}
    </Drawer>
  )
}
